<form [formGroup]="form">
  <ion-item-divider color="light">
      <ion-label >{{ dividerTitle | translate }}</ion-label>
  </ion-item-divider>

  <ion-row>
      <!-- Timed -->
      <ion-col>
        <ion-item>
          <ion-toggle justify="space-between" #isItTimed formControlName="isItTimed">{{ 'Is it timed match?' | translate }}</ion-toggle>
        </ion-item>
      </ion-col>
    </ion-row>

  <ion-row>
    <!-- Game Type -->
    <ion-col>
      <ion-item>
          <ion-select label="{{ 'Game type' | translate }}" label-placement="stacked" #setType interface="popover" formControlName="gameType">
            @if (!form.controls.isItTimed.value) {
              <ion-select-option [value]="'STANDARD'">Sideout</ion-select-option>
            }
            <ion-select-option [value]="'RALLY'">Rally</ion-select-option>
            @if (!form.controls.isItTimed.value) {
              <ion-select-option [value]="'MLP'">MLP</ion-select-option>
            }
          </ion-select>
      </ion-item>
    </ion-col>

    <!-- Number of Games-->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Games' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfGames">
          <ion-select-option [value]="1">1</ion-select-option>
          @if (form.controls.isItTimed.value) {
            <ion-select-option value="2">2</ion-select-option>
          }
          <ion-select-option [value]="3">3</ion-select-option>
          @if (form.controls.isItTimed.value) {
            <ion-select-option value="4">4</ion-select-option>
          }
          <ion-select-option [value]="5">5</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>

  @if (!form.controls.isItTimed.value) {
    <ion-row>
      <ion-col>
        <!-- Number of Points per game-->
        <ion-item>
          <ion-select label="{{ 'Points per game' | translate }}" label-placement="stacked" #gamesPerSet interface="popover" formControlName="numberOfPoints">
            <ion-select-option [value]="11">11</ion-select-option>
            <ion-select-option [value]="15">15</ion-select-option>
            <ion-select-option [value]="21">21</ion-select-option>
            <ion-select-option [value]="22">22</ion-select-option>
            <ion-select-option [value]="25">25</ion-select-option>
            <ion-select-option [value]="33">33</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <!-- Game format -->
      <ion-col>
        <ion-item>
          <ion-select label="{{ 'Game format' | translate }}" label-placement="stacked" #gameFormat interface="popover" formControlName="gameFormat">
            <ion-select-option [value]="'WIN_BY_2'">Win by 2</ion-select-option>
            <ion-select-option [value]="'DECIDING_POINT'">Deciding Point</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>
    </ion-row>

    <ion-item [hidden]="form.get('numberOfGames').value === 1">
      <ion-toggle justify="space-between" #lastSet formControlName="isLastSetDifferent">{{ 'Is the last game different?' | translate }}</ion-toggle>
    </ion-item>

    <ng-container *ngIf="form.get('isLastSetDifferent').value">

      <ion-col>
        <ion-item>
          <ion-select label="{{ 'Last game type' | translate }}" label-placement="stacked" #lastSetGameType interface="popover" formControlName="lastSetGameType">
            <ion-select-option [value]="'STANDARD'">Sideout</ion-select-option>
            <ion-select-option [value]="'RALLY'">Rally</ion-select-option>
            <ion-select-option [value]="'MLP'">MLP</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>

      <ion-row>
        <ion-col>
          <ion-item>
            <ion-select label="{{ 'Last game number of points' | translate }}" label-placement="stacked" #lastSetNumberOfPoints interface="popover" formControlName="lastSetNumberOfPoints">
              <ion-select-option [value]="11">11</ion-select-option>
              <ion-select-option [value]="15">15</ion-select-option>
              <ion-select-option [value]="21">21</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
        <ion-col>
          <ion-item>
            <ion-select label="{{ 'Last game format' | translate }}" label-placement="stacked" #lastSetGameFormat interface="popover" formControlName="lastSetGameFormat">
              <ion-select-option [value]="'WIN_BY_2'">Win by 2</ion-select-option>
              <ion-select-option [value]="'DECIDING_POINT'">Deciding Point</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
    </ng-container>
  } @else {
    <ion-col>
      <!-- Number of minutes for timbed matches-->
      <ion-item>
          <ion-input label="{{ 'Number of minutes' | translate }}" label-placement="floating" type="number" formControlName="numberOfMinutes"></ion-input>
      </ion-item>
  </ion-col>
  }


</form>